import { useContext } from "react";
import { ThemeContext } from "styled-components";
import { bindTombacStaticTool, bindTombacTool } from "./cjs/tombacCommons";
import { alpha, color } from "./tombac/colorTools";
import { parse } from "./tombac/parseTool";
import { space, unit } from "./tombac/spaceTools";
import { variant } from "./tombac/styledTools";
import { altFontFamily, altText, fontFamily, text } from "./tombac/textTools";
import { typography } from "./tombac/typography";
export * from "./tombac/tombacTypes";
export const tombac = {
  alpha,
  altFontFamily,
  altText,
  color,
  fontFamily,
  parse,
  space,
  text,
  typography,
  unit,
  variant
};
const staticTools = ["altFontFamily", "fontFamily"];
export function bindTombac(theme) {
  function isStaticTool(tool) {
    return staticTools.includes(tool);
  }
  const bound = {};
  for (const key of Object.keys(tombac)) {
    if (key !== "typography") if (isStaticTool(key)) bound[key] = bindTombacStaticTool(tombac[key], theme);else bound[key] = bindTombacTool(tombac[key], theme);
  }
  return bound;
}
export function useTombac() {
  return bindTombac(useContext(ThemeContext));
}
//# sourceMappingURL=tombac.js.map